export function unpackData(data: unknown) {
    if (Array.isArray(data)) {
        if (data.length === 0) return undefined;
        if (data.length > 1) return data.map(unpackData);
        return unpackData(data[0]);
    }

    if (data && typeof data === "object") {
        return unpackObject(data);
    }

    return data;
}

export function unpackObject(data: Object): Object {
    const remove$ = (data: Object) => {
        if (!data.hasOwnProperty("$")) return data;

        const newData = Object.assign({}, data);
        delete newData["$"];

        return {
            ...newData,
            ...data["$"],
        };
    }

    const replaceKey = (key: string, toReplace: string, data: Object) => {
        if (!data.hasOwnProperty(key)) return data;

        const newData = Object.assign({}, data);
        delete newData[key];

        return {
            ...newData,
            [toReplace]: data[key],
        };
    };

    let newData = remove$(data);
    newData = replaceKey("_", "text", newData);

    Object.keys(newData).forEach(key => {
        newData[key] = unpackData(newData[key]);
    });

    return newData;
}
